import React, { useState } from 'react';
import { Button, DatePicker } from '@bcmi-labs/react-components';
import { Trans, useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Logo } from '../../common/Logo';

import './AgeGate.scss';

const AgeGate = (props) => {
  const { t } = useTranslation('ageGate');
  const { handleSubmit, control, errors, setError, clearErrors, formState } = useForm({
    mode: 'onChange',
  });
  const [invalidDate, setinvalidDate] = useState(false);

  const { onSubmit, customDomainInfo } = props;

  const handleError = (err) => {
    if (err) {
      clearErrors(['birthday']);
      setError('birthday', { type: 'invalidDate', message: 'The Date is Invalid' });
      setinvalidDate(true);
    } else {
      clearErrors(['birthday']);
      setinvalidDate(false);
    }
  };

  const wrapperSubmitWithError = () => {
    if (!control.getValues('birthday')) {
      if (invalidDate) {
        setError('birthday', { type: 'invalidDate', message: 'The Date is Invalid' });
        return;
      }
      setError('birthday', { type: 'requiredDate', message: t('register:fieldRequired') });
    } else {
      onSubmit(control.getValues('birthday'));
    }
  };

  return (
    <section className="age-gate">
      <Logo customLogo={customDomainInfo?.organization_logo} />
      <h1 className="arduino-typography-large">
        <Trans i18nKey="ageGate:title" components={[<span className="junior-text-color" key="junior-account" />]} />
      </h1>
      <p className="description">{t('ageGate:description')}</p>
      <form onSubmit={handleSubmit(wrapperSubmitWithError)} noValidate>
        <div className="form-row">
          <Controller
            render={({ onChange, onBlur, value }) => (
              <DatePicker
                error={errors.birthday && errors.birthday.type === 'requiredDate' && errors.birthday.message}
                maxDate={new Date()}
                minDate={new Date(1920, 1, 1, 0, 0, 0)}
                infoMsg={null}
                onBlur={onBlur}
                onChange={(e) => onChange(e)}
                onError={handleError}
                value={value}
                required
              />
            )}
            name="birthday"
            control={control}
            defaultValue=""
          />
        </div>

        <Button type="submit" isDisabled={!formState.isValid || !control.getValues('birthday')}>
          {t('register:next')}
        </Button>
      </form>

      <div className="spacer"></div>
    </section>
  );
};

AgeGate.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  customDomainInfo: PropTypes.object,
};

export default AgeGate;
